module.exports = __webpack_public_path__ + "static/img/logo.0610c72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 864
// module chunks = 1